import React from "react";
import "./index.css";
import Navbar from "./navbar";
import Banner from "./banner";
import Sidemenu from "./sidemenu";

let onClick = e => {
  e.preventDefault();
  console.log("onclick..");
};
function Header() {
  return (
    <header className="header" data-scroll-index="0">
      <Navbar />
      <Banner />
      <Sidemenu />
      <a id="close_sidebar" onClick={onClick} />
    </header>
  );
}

export default Header;
